import { Form, TimePicker } from "antd";

export default function RenderTimePicker(props) {
	const { namePath = [], required = false } = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Form.Item
			name={newNamePath}
			rules={[
				{
					required: required ? true : false,
					message: "This field is required!",
				},
			]}
		>
			<TimePicker style={{ width: "100%" }} />
		</Form.Item>
	);
}
